import { apiServiceInstanceQuestionBuilder } from '../apiUtils';

export const getFeatureUpdates = async () => {
  try {
    const response = await apiServiceInstanceQuestionBuilder.get('/features/updates');
    return response.data;
  } catch (error) {
    return null;
  }
};

export const markFeaturesSeen = async (featureIds: number[]) => {
  try {
    const response = await apiServiceInstanceQuestionBuilder.post('/features/updates/seen', {
      featureIds,
    });
    return response.data;
  } catch (error) {
    return null;
  }
};

export const markAllFeaturesSeen = async () => {
  try {
    const response = await apiServiceInstanceQuestionBuilder.post('/features/updates/seen/all');
    return response.data;
  } catch (error) {
    return null;
  }
};
